diy.angular.registerFactory('diyfmsectionstorage', [
    '$timeout', 
    'diyl10n', 
    'diyfmsectionmodel', 
    'diyfmfoldermodel', 
    'diyfmconststorage', 
    'diyfmunsortedmodel',
    'diyappevents',
    'diyfmfolders',
    'diywebsiteid',
    'diyfmsourcestorage',
    'diyfmallimagesmodel',
function(
    $timeout, 
    diyl10n, 
    diyfmsectionmodel, 
    diyfmfoldermodel, 
    diyfmconststorage, 
    diyfmunsortedmodel,
    diyappevents,
    diyfmfolders,
    diywebsiteid,
    diyfmsourcestorage,
    diyfmallimagesmodel
) {

    var model = diy.core.namespace('diy.editor.fm.model');

    // constructor
    var diyfmsectionstorage = function () {
        diyfmsectionmodel.call(this, 'customerSection', diyl10n('filemanager.customerSection.title')); //call parent constructor
    }; 
    
    // diyfmsectionstorage extends diyfmsectionmodel
    diyfmsectionstorage.prototype = Object.create(diyfmsectionmodel.prototype);
    
    // static methods
    diyfmsectionstorage.getOrder = function() {
        return 0;
    };
    
    // public methods
    angular.extend(diyfmsectionstorage.prototype, {
        initializeSubsections: function(sources) {
        	// call parent
            diyfmsectionmodel.prototype.initializeSubsections.apply(this, arguments);
            
            this._allimagesFolder = new diyfmallimagesmodel(diyl10n('filemanager.customerSection.allImagesFolder'));
            this.addSubsection(this._allimagesFolder);
            this._unsortedFolder = new diyfmunsortedmodel(
                diyl10n('filemanager.customerSection.unsortedFolder')
            );
            this.addSubsection(this._unsortedFolder, 1);
            
            /* get the folders from the server */
            diyfmfolders.query(function(folders){
                var i;

                for (i = 0; i < folders.length; i++) {
                    this.addSubsection(new diyfmfoldermodel({
                        type: diyfmconststorage,
                        id: parseInt(folders[i].id, 10)
                    }, folders[i].name, folders[i]));
                }
                diyappevents.trigger('subSectionsLoaded', 'diyfmsourcestorage');
            }.bind(this)); 
            
            this._actions.push({
                title: diyl10n('filemanager.customerSection.addFolder'),
                handler: function($event, section) {
                    var newSubsection = new diyfmfoldermodel({type: diyfmconststorage, id: null}, '');
                    section.addSubsection(newSubsection);
                    $event.stopPropagation();
                },
                icon: 'ui-icon-1and1-add-folder'
            });
        },
        addSubsection: function(subsection, index) {
            // call parent method
            if (index !== undefined) {
                diyfmsectionmodel.prototype.addSubsection.apply(this, arguments);
            } else {
                // user generated folders should be inserted before the last ("Unsorted")
                diyfmsectionmodel.prototype.addSubsection.apply(this, [subsection, -1]);
            }
            
            if (this._allimagesFolder && !(subsection instanceof diyfmallimagesmodel)) {
                subsection.attachObserver(this._allimagesFolder);
                this._allimagesFolder.attachObserver(subsection);
            }
        },
        getFolderSectionById: function(folderId) {
            for(var i = 0, len = this._subsections.length; i < len; i++) {
                if (this._subsections[i].getFolderId() == folderId
                   && this._allimagesFolder !== this._subsections[i]
                ) {
                    return this._subsections[i]; 
                }
            }
        },
        getDefaultUploadSubsection: function() {
            return this._unsortedFolder;
        },
        getAllImagesSubsection: function() {
            return this._allimagesFolder;
        }
    });
    
    return diyfmsectionstorage;
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/sections/diyfmsectionstorage.js
 ** module id = 961
 ** module chunks = 0
 **/